// extracted by mini-css-extract-plugin
module.exports = {"map":"ViewMap_map__3ntKB"};